

























import { Component, Prop, Vue } from 'vue-property-decorator';

import PermissionsSelector from './PermissionsSelector.vue';
import { Permission, PermissionCategory, UserDetailsViewModel } from '@/types/apiServerContract';
import { User } from '@/models/user/user.model';

@Component({
    components: { PermissionsSelector }
})
export default class EditUserPermissions extends Vue {
	@Prop({ required: true }) permissions!: Permission[];
	@Prop({ required: true }) categories!: PermissionCategory[];
	@Prop({ required: true }) user!: User;
	@Prop({ required: true }) userData!: UserDetailsViewModel;
	@Prop({ required: true }) activeRealmId!: number;

	loading: boolean = false;
	locked: boolean = false;

	PermissionsByCategory(category: number) {
	    return this.permissions.filter(x => x.categoryId === category).sort((a, b) => (a.name > b.name ? 1 : -1));
	}
}
